module.exports = __webpack_public_path__ + "static/media/Office86_in.9670e623.jpg";